import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=73812f76&scoped=true"
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=73812f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73812f76",
  null
  
)

export default component.exports